import { render, staticRenderFns } from "./KEmptyPlaceholder.vue?vue&type=template&id=9f867efa&scoped=true&"
import script from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./KEmptyPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f867efa",
  null
  
)

export default component.exports